












































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import usuarioModule from "@/store/usuario/UsuarioModule";
import { EstadoModel, estadosList } from "@/models/commons/EstadoModel";
import { EnderecoModel } from "@/models/cadastros/assistencia/agente/EnderecoModel";
import {
  tiposTelefoneList,
  ITelefoneModel,
} from "@/models/commons/TelefoneModel";
import { tiposResponsavelList } from "@/models/commons/ResponsavelModel";
import { tiposEnderecoList } from "@/models/commons/EnderecoModel";
import { tiposVeliculoList, TipoVeiculoModel, } from "@/models/commons/TipoVeiculoModel";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import ServicosAssistenciaService from "@/service/assistencia24h/ServicosAssistenciaService";
import { mapasService } from "@/service/MapasService";
import { moneyMaskProperties } from "@/models/VuetifyMoneyModel";
import { VeiculoModel } from "@/models/veiculo/VeiculoModel";
import { SegmentoDTO } from "@/models/commons/SegmentoModel";
import { AgenteModel, ListaAgentesModel } from "@/models/cadastros/assistencia/agente/AgenteModel";
import {TipoBancoModel} from "@/models/commons/TipoBancoModel";
import { BancoDTO } from "@/models/commons/BancoModel";
import { IContatoModel } from '@/models/cadastros/assistencia/agente/ContatoModel';
import { IComissionamentoModel, TiposComissionamentoList } from '@/models/cadastros/assistencia/agente/ComissionamentoModel';
import { IInformacaoModel } from '@/models/cadastros/assistencia/agente/InformacaoModel'; 
import { tipoServicoVeicularList } from "@/models/commons/TipoServicoModel";
// @ts-ignore
import _ from 'lodash';
import moment from "moment";
import { throws } from "assert";
import { BIconShift } from "bootstrap-vue";

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    GsModalDialog
  },
})
export default class CadastroAgente extends Vue {
  $refs!: {
    dadosBasicosObserver: InstanceType<typeof ValidationObserver>;
    telefoneObserver: InstanceType<typeof ValidationObserver>;
    informacaoObserver: InstanceType<typeof ValidationObserver>;
    enderecoObserver: InstanceType<typeof ValidationObserver>;
    comissionamentoObserver: InstanceType<typeof ValidationObserver>;  
  };
  segmentos: SegmentoDTO[] = [];
  listaBancos: TipoBancoModel[] = [];
  endereco: EnderecoModel = {};
  segmento: any;
  comissionamento : IComissionamentoModel = {};
  itemParaExcluir: any;
  tiposServicos = tipoServicoVeicularList;

  agente: AgenteModel = {
    contaBancaria: {},
    enderecos: [],
    contatos: [],
    comissionamentos: [],
    informacoes: []
  };

  telefone: ITelefoneModel = {};
  informacao: IInformacaoModel = {};
  contato: IContatoModel = {};

  moneyMaskProperties = moneyMaskProperties;
  telefoneValido = false;
  veiculoValido = false;
  informacaoValido = false;
  enderecoValido = false;
  comissionamentoValido = false;

  tiposVeiculos = tiposVeliculoList;

  loadingAddress = false;
  ehLeveUtilitario = false;
  ehPesadoExtraPesado = false;

  estados = estadosList;
  cidades: string[] = [];
  bancos: BancoDTO[] = [];
  contatoIndex = 0;
  enderecoIndex = 0;
  comissionamentoIndex = 0;
  informacaoIndex = 0;

  tiposResponsavel = tiposResponsavelList;
  tiposTelefone = tiposTelefoneList;
  tipoVeiculo = tiposVeliculoList;
  tiposEndereco = tiposEnderecoList;
  listaAgentes: ListaAgentesModel[] = [];

  cabecalhoTelefone = [
    { text: "Tipo Número", value: "tipo.descricao" },
    { text: "Número", value: "numero" },
    { text: "Ramal", value: "ramal" },
    { text: "E-mail", value: "email" },
    { text: "Ações", value: "actions", sortable: false },
  ];

  cabecalhoComissionamento = [
    { text: "Tipo Serviço", value: "tipoServico.descricao" },
    { text: "Perc. Comissão", value: "percentualComissao" },
    { text: "Pessoa Repasse", value: "pessoaRepasse.cpfCnpjNome" },
    { text: "Perc. Repasse", value: "percentualRepasse" },
    { text: "Agravo", value: "agravo" },
    { text: "Desconto", value: "desconto" },
    { text: "Ações", value: "actions", sortable: false },
  ];

  cabecalhoInformacao = [
    { text: "Data", value: "dataCriacao", width: "15%" },
    { text: "Usuário", value: "usuario", width: "15%" },
    { text: "Registo", value: "registro", width: "55%" },
    { text: "Ações", value: "actions", sortable: false },
  ];

  cabecalhoEndereco= [
    { text: "Cep", value: "cep"},
    { text: "Tipo Endereço", value: "tipo.descricao"},
    { text: "Logradouro", value: "logradouro" },
    { text: "Número", value: "numero"},
    { text: "Complemento", value: "complemento"},
    { text: "Bairro", value: "bairro"},
    { text: "Estado", value: "estado.sigla"},
    { text: "Cidade", value: "cidade"},
    { text: "Ações", value: "actions", sortable: false },
  ];


  tipoPopup = "";
  dialogType = "success";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  loading = false;
  
  @Watch('endereco.cep')
  private consultCEP(val: string): void {
    if (val != undefined) {
      this.requestAddress(val);
    }
  }

  async obterBancos() {
    this.loading = true;
    this.bancos = [];
    ServicosAssistenciaService
    .obterBancos().then((res: BancoDTO[]) => {
          this.bancos = res;
          this.loading = false;
          this.formatarBancos();
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  formatarBancos() {
    for (var val of this.bancos) {
      this.listaBancos.push({ value: val.id, descricao: val.id + " - " + val.descricao });
    }
  }

  requestAddress(val: string): void {
    val = val.replace(/\D/g, "");
    if (val && val.length === 8) {
      this.loadingAddress = true;
      mapasService
        .obterEnderecoPorCep(val.replace(/\D/g, ""))
        .then((res) => {
          const address: EnderecoModel = this.endereco ?? {};

          if (res.logradouro) {
            address.logradouro = res.logradouro;
          }
          if (res.bairro) {
            address.bairro = res.bairro;
          }
          if (res.cidade) {
            address.cidade = res.cidade;
          }

          if (res.estado) {
            address.estado = estadosList.find(
              (e) => e.sigla == (res.estado?.sigla || "")
            );
          } else {
            address.estado = undefined;
          }
          this.endereco = address;
        })
        .finally(() => {
          this.loadingAddress = false;
        });
    } else {
      if (val && val.length < 8) {
        this.limparEndereco();
      }
    }
  }

  limparEndereco() {

    let enderecoLimpo: EnderecoModel = {
      cep: "",
      logradouro: "",
      numero: undefined,
      complemento: "",
      bairro: "",
      cidade: "",
      estado: undefined,
    };

    this.endereco = enderecoLimpo;
  }

  async obterSegmentos() {
    this.loading = true;
    this.segmentos = [];
    ServicosAssistenciaService
      .obterSegmentos(
    ).then((res: SegmentoDTO[]) => {
      this.segmentos = res;

      this.segmentos = _.orderBy( this.segmentos, ['descricao']);

      this.loading = false;
    })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  loadInfo() {
    this.telefone = {};
    this.informacao = {};
    this.contato = {};
    this.comissionamento = {};
    this.agente = {
      contaBancaria: {},
      enderecos: [],
      contatos: [],
      comissionamentos: [],
      informacoes: []
    };

    // carregar as infos
    if (this.$route.params.idCliente) {
      ServicosAssistenciaService.obterAgente(
        this.$route.params.idCliente
      ).then((response) => {
        const resultado = response.data;
        this.agente = {
          id: resultado.id,
          cpfCnpj: resultado.cpfCnpj,
          nome: resultado.nome,
          segmento: resultado.segmento,
          tipoPessoaString: resultado.tipoPessoa.substring(0, 1),
          ativo: resultado.tivo,
          contaBancaria: resultado.contaBancaria,
          enderecos: resultado.enderecos.map((e: any, index: number) => {
            const enderecoModel: EnderecoModel = {
            id: index,
            cep: e.cep,
            tipo: this.tiposEndereco.find((s) => e.tipo == s.nome),
            logradouro: e.logradouro,
            numero: e.numero,
            complemento: e.complemento,
            bairro: e.bairro,
            cidade: e.cidade,
            estado: this.estados.find((s) => e.estado == s.sigla),
          };
            return enderecoModel;
          }),
          contatos: resultado.contatos.map((c: any, index: number) => {
            const contatoModel : IContatoModel = {
              id: index,
              numero: `(${c.ddd}) ${c.numero}`,
              ramal: c.ramal,
              tipo: this.tiposTelefone.filter((tipo) => {
                return tipo.nome == c.tipo;
              })[0],
              email: c.email
            };
            return contatoModel;
          }),
          comissionamentos: resultado.comissionamentos.map((c: any, index: number) => {
            const comissionamentoModel : IComissionamentoModel = {
              id: index,
              tipoServico: this.tiposServicos.find((srv) => srv.name == c.tipoServico),
              percentualComissao: c.percentualComissao,
              pessoaRepasse: this.listaAgentes.find(item => item.id === c.pessoaRepasse),
              percentualRepasse: c.percentualRepasse,
              agravo: c.agravo,
              desconto: c.desconto
            };
            return comissionamentoModel;
          }),
          informacoes: resultado.informacoes.map((i: any, index: number) => {
            const informacoesModel : IInformacaoModel = {
              id: index,
              registro: i.registro,
              usuario: i.usuario,
              dataCriacao: i.dataCriacao
            };
            return informacoesModel;
          }),
        }
        this.contatoIndex = this.agente.contatos?.length || 0;
        this.enderecoIndex = this.agente.enderecos?.length || 0;
        this.comissionamentoIndex = this.agente.comissionamentos?.length || 0;
        this.informacaoIndex = this.agente.informacoes?.length || 0;
      });
    }
  }

  async mounted() {
    this.tiposServicos = tipoServicoVeicularList;
    await this.listarAgentes();
    this.obterSegmentos();
    this.obterBancos();
    this.loadInfo();
  }

  //Computed properties
  get textoBotaoTelefone() {
    return this.contato &&
      this.contato?.id !== undefined &&
      this.contato?.id >= 0
      ? "Salvar contato"
      : "Adicionar contato";
  }

  get textoBotaoEndereco() {
    return this.endereco &&
      this.endereco?.id !== undefined &&
      this.endereco?.id >= 0
      ? "Salvar endereço"
      : "Adicionar endereço";
  }

  get textoBotaoComissionamento() {
    return this.comissionamento &&
      this.comissionamento?.id !== undefined &&
      this.comissionamento?.id >= 0
      ? "Salvar comissionamento"
      : "Adicionar comissionamento";
  }

  get textoBotaoInformacao() {
    return this.informacao &&
      this.informacao?.id !== undefined &&
      this.informacao?.id >= 0
      ? "Salvar Informação"
      : "Adicionar Informação";
  }

  removerVeiculo(veiculo: VeiculoModel) {    
    this.itemParaExcluir = veiculo;
    this.excluir('Deseja realmente excluir o veículo? Se confirmar, poderá perder os dados.', 'VEICULO');
  }

  // TELEFONE
  adicionarTelefone() {
    this.$refs.telefoneObserver.validate().then((res: boolean) => {
      if (res) {
        if (!this.agente.contatos) {
          this.agente.contatos = [this.contato];
        }
        const partes = this.contato.numero?.split(" ") as string[];
        if (partes.length == 3) {
          this.contato.numero = `${partes[0]} ${partes[1]}${partes[2]}`;
        }

        const idx = this.agente.contatos
          .map((t) => t.id)
          .indexOf(this.contato.id);

        if (idx >= 0) {
          this.agente.contatos.splice(idx, 1, this.contato);
        } else {
          this.contato.id = this.contatoIndex++;
          this.agente.contatos.push(this.contato);
        }
        this.contato = {};
        this.$refs.telefoneObserver.reset();
      }
    });
  }

  alterarTelefone(telefone: IContatoModel) {
    this.contato = Object.assign({}, telefone);
  }

  alterarComissionamento(comissionamento: IComissionamentoModel) {
    this.comissionamento = Object.assign({}, comissionamento);
  }

  removerTelefone(telefone: IContatoModel) {
    this.itemParaExcluir = telefone;
    this.excluir('Deseja realmente excluir o contato? Se confirmar, poderá perder os dados.', 'CONTATO');
  }

  removerComissionamento(comissionamento: IComissionamentoModel) {
    this.itemParaExcluir = comissionamento;
    this.excluir('Deseja realmente excluir o comissionamento? Se confirmar, poderá perder os dados.', 'COMISSIONAMENTO');
  }

  removerTelefoneConfirmation() {    
    if (this.agente.contatos) {
      const idx = this.agente.contatos
        .map((t) => t)
        .indexOf(this.itemParaExcluir);
      this.agente.contatos.splice(idx, 1);
    }
  }

  cancelarTelefone() {
    this.contato = {};
  }

  cancelarComissionamento() {
    this.comissionamento = {};
  }

  cancelarEndereco() {
    this.endereco = {};
  }

  // INFORMACAO
  get nomeLogin() {
    const nome = usuarioModule.token?.name.split(" ");
    if (nome) {
      return nome.length > 1
        ? `${nome[0]} ${nome[1]}${nome[1].length < 3 && nome[2] ? ` ${nome[2]}` : ""
        }`
        : nome[0];
    } else {
      return "";
    }
  }

  adicionarEndereco() {
    this.$refs.enderecoObserver.validate().then((res: boolean) => {
      if (res) {
        if (!this.agente.enderecos) {
          this.agente.enderecos = [this.endereco];
        }

        const idx = this.agente.enderecos
          .map((t) => t.id)
          .indexOf(this.endereco.id);

        if (idx >= 0) {
          this.agente.enderecos.splice(idx, 1, this.endereco);
        } else {
          this.endereco.id = this.enderecoIndex++;
          this.agente.enderecos.push(this.endereco);
        }
        this.endereco = {};
        this.$refs.enderecoObserver.reset();
      }
    });
  }

  adicionarComissionamento() {
    this.$refs.comissionamentoObserver.validate().then((res: boolean) => {
      if (res) {
        if (!this.agente.comissionamentos) {
          this.agente.comissionamentos = [this.comissionamento];
        }

        const idx = this.agente.comissionamentos
          .map((t) => t.id)
          .indexOf(this.comissionamento.id);

        if (idx >= 0) {
          this.agente.comissionamentos.splice(idx, 1, this.comissionamento);
        } else {
          this.comissionamento.id = this.comissionamentoIndex++;
          this.agente.comissionamentos.push(this.comissionamento);
        }
        this.comissionamento = {};
        this.$refs.comissionamentoObserver.reset();
      }
    });
  }

  adicionarInformacao() {
    this.$refs.informacaoObserver.validate().then((res: boolean) => {
      if (res) {
        if (!this.agente.informacoes) {
          this.informacao.usuario = this.nomeLogin;
          this.informacao.dataCriacao = moment().format("YYYY-MM-DDTHH:mm:ss");
          this.agente.informacoes = [this.informacao];
        }

        const idx = this.agente.informacoes
          .map((t) => t.id)
          .indexOf(this.informacao.id);

        if (idx >= 0) {
          this.agente.informacoes.splice(idx, 1, this.informacao);
        } else {
          this.informacao.id = this.informacaoIndex++;
          this.informacao.usuario = this.nomeLogin;
          this.informacao.dataCriacao = moment().format("YYYY-MM-DDTHH:mm:ss");
          this.agente.informacoes.push(this.informacao);
        }
        this.informacao = {};
        this.$refs.informacaoObserver.reset();
      }
    });
  }

  alterarInformacao(informacao: IInformacaoModel) {
    this.informacao = Object.assign({}, informacao);
  }

  removerInformacao(informacao: IInformacaoModel) {
    this.itemParaExcluir = informacao;
    this.excluir('Deseja realmente excluir a informação? Se confirmar, poderá perder os dados.', 'INFORMACAO');
  }

  alterarEndereco(endereco: EnderecoModel) {
    this.endereco = Object.assign({}, endereco);
  }

  removerEndereco(endereco: EnderecoModel) {
    this.itemParaExcluir = endereco;
    this.excluir('Deseja realmente excluir o endereço? Se confirmar, poderá perder os dados.', 'ENDERECO');
  }

  removerInformacaoConfirmation() {    
    if (this.agente.informacoes) {
      const idx = this.agente.informacoes
        .map((t) => t)
        .indexOf(this.itemParaExcluir);
      this.agente.informacoes.splice(idx, 1);
    }
  }

  removerComissionamentoConfirmation() {    
    if (this.agente.comissionamentos) {
      const idx = this.agente.comissionamentos
        .map((t) => t)
        .indexOf(this.itemParaExcluir);
      this.agente.comissionamentos.splice(idx, 1);
    }
  }
  
  removerEnderecoConfirmation() {    
    if (this.agente.enderecos) {
      const idx = this.agente.enderecos
        .map((t) => t)
        .indexOf(this.itemParaExcluir);
      this.agente.enderecos.splice(idx, 1);
    }
  }
  
  cancelarInformacao() {
    this.informacao = {};
  }

  excluir(mensagem: string, tipo: string) {
    // 'Deseja realmente excluir o veículo? Se confirmar, poderá perder os dados.'
    this.openDialog('confirm', 'Atenção', mensagem, tipo);
  }

  cancelar() {
    this.openDialog('confirm', 'Cancelar alterações', 'Deseja realmente cancelar o cadastro? Se confirmar, poderá perder os dados.', 'IGNORE');
  }

  voltarPagina() {
    this.$router.back();
  }

  async listarAgentes() {
    this.loading = true;
    this.listaAgentes = [];
    ServicosAssistenciaService
    .listarAgentes().then((res: any) => {
          this.listaAgentes = res;
          this.loading = false;
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      });
  }

  gravar() {
    this.$refs.dadosBasicosObserver.validate().then((valid) => {
      if (valid) {
        if (!this.agente.enderecos || this.agente.enderecos.length <= 0) {
          this.openDialog('error', 'Nenhum endereço adicionado', 'Nenhum endereço foi adicionado.');
          valid = false;
        }

        if (!this.agente.contatos || this.agente.contatos.length <= 0) {
          this.openDialog('error', 'Nenhum contato adicionado', 'Nenhum contato foi adicionado.');
          valid = false;
        }

        if (valid) {
          if (this.agente.id) {
            this.save();
          } else {
            ServicosAssistenciaService.verificarCpfCnpjAgente(
              this.agente.cpfCnpj || ""
            ).then((existe: any) => {
              if (!existe.data) {
                this.save();
              } else {
                this.openDialog('error', 'Agente já cadastrado', `Já existe um agente cadastrado para o CNPJ informado.`);
              }
            });
          }
        }
      } else {
        setTimeout(() => {
          const errors = Object.entries(this.$refs.dadosBasicosObserver.errors)
            .map(([key, value]) => ({ key, value }))
            .filter((error) => error["value"].length);
          this.$refs.dadosBasicosObserver.refs[
            errors[0]["key"]
          ].$el.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }, 100);
      }
    });
  }

  save() {
   this.loading = true;
    ServicosAssistenciaService.saveAgente(this.agente).then(
      (res) => {
        if (this.agente.id) {
          this.dialogTitle = "Alteração efetivada com sucesso";
          this.dialogMessage = "Agente alterado com sucesso";
        } else {
          this.dialogTitle = "Cadastro efetivado com sucesso";
          this.dialogMessage = "Cadastro do agente efetivado com sucesso";
        }
        this.openDialog('success', this.dialogTitle, this.dialogMessage);
        this.loading = false;
      },
      (err) => {
        this.openDialog('error', 'Erro ao gravar agente', 'Ocorreu um erro ao tentar gravar os dados do agente.');
        this.loading = false;
      }
    );
  }

  private openDialog(dialogType: string, title: string, message: string, type?: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;

    if (dialogType == 'confirm') {
      this.tipoPopup = type!!;
    }
  }

  public closeDialog(): void {
    this.showDialog = false;
    if (this.dialogType === 'success') {
      this.$router.push({ name: "ListaAgentes" });
    }
  }

  public confirm() {
    this.closeDialog();
    if (this.tipoPopup == 'CONTATO') {
      this.removerTelefoneConfirmation();
    } else if (this.tipoPopup == 'INFORMACAO') {
      this.removerInformacaoConfirmation();
    } else if (this.tipoPopup == 'ENDERECO') {
      this.removerEnderecoConfirmation();
    } else if (this.tipoPopup == 'COMISSIONAMENTO') {
      this.removerComissionamentoConfirmation();
    }
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "warning";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
